export const menuOffset: number[] = [0, 4]
export const menuOffsetSide: number[] = [4, 0]
